import { render, staticRenderFns } from "./TicketBlock.vue?vue&type=template&id=09005922"
import script from "./TicketBlock.vue?vue&type=script&lang=js"
export * from "./TicketBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports